import { useState } from "react";
import MonthDropdown from "./MonthDropdown";

const TotalUsageSelector = ({
	usageData,
	currentUtcMonth,
	previousUtcMonth,
	currentUtcYear,
	index = 0,
}) => {
	const [selectedMonth, setSelectedMonth] = useState("thisMonth");

	const monthToDate = {
		thisMonth: {
			month: currentUtcMonth,
			year: currentUtcYear,
		},
		lastMonth: {
			month: previousUtcMonth,
			year: currentUtcMonth === 1 ? currentUtcYear - 1 : currentUtcYear,
		},
	};

	const { month, year } = monthToDate[selectedMonth];

	const usageForMonth = usageData?.subscriptions?.find(
		(sub) => Number(sub.month) === Number(month) && Number(sub.year) === Number(year),
	)?.usage;

	return (
		<div
			className={`mb-4 rounded border-dark-blue bg-dark-blue px-0 py-2 ${
				index !== 0 ? "mt-4" : ""
			}`}
		>
			<div className="flex items-center justify-between">
				<MonthDropdown selectedMonth={selectedMonth} onSelect={setSelectedMonth} />
				<span className="m-2 p-1 font-semibold text-white text-xs sm:text-sm md:text-sm lg:text-md">
					Total Priority Usage
				</span>

				<span className="m-2 rounded bg-green-cyan p-1 font-normal text-green-300 text-xs sm:text-sm md:text-sm lg:text-md">
					{usageForMonth ? `${usageForMonth} GB` : "N/A"}
				</span>
			</div>
		</div>
	);
};

export default TotalUsageSelector;
